import {ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {DataService} from '../services/data.service';
import {Subscription} from 'rxjs';
import {AdminUser} from '../models/api.models';

@Component({
    selector: 'app-central',
    templateUrl: './central.component.html',
    styleUrls: ['./central.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CentralComponent implements OnInit, OnDestroy {

    userInfo?: AdminUser;
    isMobileSidebarOpen = false;
    dataChangedSessionSubscription: Subscription;

    constructor(private dataService: DataService) {
    }

    ngOnInit() {
        this.userInfo = this.dataService.getUserInfo();
        this.dataChangedSessionSubscription = this.dataService.dataChangedSession.subscribe(() => {
            this.userInfo = this.dataService.getUserInfo();
        });
    }

    ngOnDestroy() {
        if (this.dataChangedSessionSubscription) {
            this.dataChangedSessionSubscription.unsubscribe();
        }
    }

    toggleMobileSidebar() {
        this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen = false;
    }

    @HostListener('document:keydown.escape')
    onEscapeKey() {
        this.closeMobileSidebar();
    }

}
